import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-export-historico-placa',
  templateUrl: './export-historico-placa.component.html',
  styleUrls: ['./export-historico-placa.component.sass']
})
export class ExportHistoricoPlacaComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
